export enum ReportOwnerCategoryEnum {
  Global = "Global",
  AllUsers = "AllUsers",
  UserOnly = "UserOnly",
}
